import { ReactNode } from "react";
import { Link } from "react-router-dom";

import { cn } from "../../../lib/utils";

interface AuthTextLinkProps {
  to: string;
  state?: unknown;
  children: ReactNode;
  className?: string;
}

export const AuthTextLink = ({ to, state, children, className }: AuthTextLinkProps) => (
  <Link
    to={to}
    state={state}
    className={cn("tw-block tw-text-sm tw-text-primary hover:tw-underline", className)}
  >
    {children}
  </Link>
);
